const ZERO_VALUE = '0.00';

export const normalizeCurrencyValue = (valor) => {
  if (valor === null || valor === undefined || valor === '') {
    return ZERO_VALUE;
  }

  if (typeof valor === 'number') {
    return Number.isFinite(valor) ? valor.toFixed(2) : ZERO_VALUE;
  }

  const texto = String(valor).trim();

  if (!texto) {
    return ZERO_VALUE;
  }

  const apenasNumeros = texto.replace(/[^\d.,-]/g, '');

  if (!apenasNumeros) {
    return ZERO_VALUE;
  }

  const possuiVirgula = apenasNumeros.includes(',');
  const semSeparadores = possuiVirgula
    ? apenasNumeros.replace(/\./g, '')
    : apenasNumeros;

  const padronizado = semSeparadores.replace(',', '.');
  const numero = Number(padronizado);

  if (!Number.isFinite(numero)) {
    return ZERO_VALUE;
  }

  return numero.toFixed(2);
};

export const currencyStringToCents = (valor) => {
  const normalizado = normalizeCurrencyValue(valor);
  const numero = Number(normalizado);

  if (!Number.isFinite(numero)) {
    return 0;
  }

  return Math.max(0, Math.round(numero * 100));
};

export const centsToCurrencyString = (cents) => {
  if (typeof cents !== 'number' || !Number.isFinite(cents)) {
    return ZERO_VALUE;
  }

  const seguro = Math.max(0, Math.floor(cents));
  return (seguro / 100).toFixed(2);
};
